import { convertObjectToSingleString } from '../../../../../utils/helper';
import { PRE, CODE } from '../../../utils/editorStyles.constants';
export const getCodeBlockNode = options => ({
  content: 'text*',
  marks: '',
  group: 'block',
  code: true,
  defining: true,
  parseDOM: [{
    tag: 'pre',
    preserveWhitespace: 'full'
  }],
  toDOM() {
    const {
      hasInlineStyles
    } = options;
    if (hasInlineStyles) {
      return ['pre', {
        style: convertObjectToSingleString(PRE)
      }, ['code', {
        style: convertObjectToSingleString(CODE)
      }, 0]];
    } else {
      return ['pre', {}, ['code', {}, 0]];
    }
  }
});